<template>
  <div
    :class="
      $style['promotion']
    "
    @click="onClick">
    <div :class="$style['promotion__inner']">
      <img alt="GUTS *ON THE GO* COLLECTION" :class="$style['promotion__title']" src="/images/promotions/travel/guts-on-the-go-title.svg?url">

      <btn
        v-if="(promotionData.link && promotionData.showLink) && shouldShow(promotionData.link)"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"

        shape="round" />
    </div>
  </div>
</template>
<script>
import baseScript from './Shared/script'
export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/travel/guts-on-the-go.webp');

  &__inner {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__title {
    width: 60%;
    margin-bottom: calc(var(--spacing ) * 3);
  }
}
</style>
